import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { color } from "../../../../../config";

export const InsertHoverArea = ({
  // index,
  onInsert,
  isVisible,
  onHover,
  onLeave,
}: {
  index: number;
  onInsert: () => void;
  isVisible: boolean;
  onHover: () => void;
  onLeave: () => void;
}) => (
  <Box
    sx={{ height: 20, width: "100%", border: `1px solid ${color.background}` }}
    onMouseEnter={onHover}
    onMouseLeave={onLeave}
  >
    {isVisible && (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        paddingX={2}
        sx={{
          height: 32,
          backgroundColor: "#f0f0f0",
          "&:hover": {
            backgroundColor: "#e0e0e0",
            cursor: "pointer",
          },
        }}
        onClick={onInsert}
      >
        <Typography variant="label_S" color="textSecondary" marginBottom={1}>
          ＋設問を追加
        </Typography>
      </Stack>
    )}
  </Box>
);
